export default class Drop {
  constructor() {
    this._dropInit = document.querySelectorAll(".jsDropInit");
    this._drop = document.querySelectorAll(".jsDrop");
    this._dropClose = document.querySelectorAll(".jsDropClose");

    if (this._dropInit) this.init();
  }

  searchDrawer(type, i) {
    let z = this._drop.length;
    for (let y = 0; y < z; y++) {
      if (this._drop[y].dataset.drop == i.dataset.drop) {
        switch (type) {
          case "OPEN":
            this._drop[y].classList.add("active");
            break;
          case "CLOSE":
            this._drop[y].classList.remove("active");
            break;
        }
      }
    }
  }

  init() {
    let l = this._dropInit.length;
    for (let i = 0; i < l; i++) {
      this._dropInit[i].addEventListener("click", () => {
        this.searchDrawer("OPEN", this._dropInit[i]);
      });
    }

    l = this._dropClose.length;
    for (let i = 0; i < l; i++) {
      this._dropClose[i].addEventListener("click", () => {
        this.searchDrawer("CLOSE", this._dropClose[i]);
      });
    }
  }
}
